import Banner from "../../../components/common/Banner";
import Brands from "../../../components/common/Brands";
import Testimonials from "../../../components/common/Testimonials";
import Testimonials2 from "../../../components/common/Testimonials2";
import Footer1 from "../../../components/footer/Footer1";
import Header1 from "../../../components/headers/Header1";
import Faqs from "../../../components/common/Faqs";
import PageTitle2 from "../../../components/blogs/PageTitle2";
import Services from "../../../components/otherPages/services/Services";
import React from "react";

import MetaComponent from "../../../components/common/MetaComponent";

export default function OurServicePage() {

  const [MetaTitle, setMetaTitle] = React.useState("Our Services || AskMeRealty - Real Estate Services");
  const [MetaDescription, setMetaDescription] = React.useState("AskMeRealty - Our Services include property buying, selling, renting, and property management. We provide comprehensive real estate solutions to meet your needs.");
  const [MetaKeywords, setMetaKeywords] = React.useState("Our Services, AskMeRealty, Real Estate Services, Property Buying, Property Selling, Property Renting, Property Management, Real Estate Solutions");
  const [MetaImage, setMetaImage] = React.useState("");

  const metadata = {
    title: MetaTitle,
    description: MetaDescription,
    keywords: MetaKeywords,
    url: window.location.href,
    siteName: "AskMeRealty",
    canonical: window.location.href,
    image: MetaImage,
  };
  return (
    <>
      <MetaComponent meta={metadata} />
      <Header1 />
      <PageTitle2 setMetaTitle={setMetaTitle} setMetaDescription={setMetaDescription} setMetaKeywords={setMetaKeywords} setMetaImage={setMetaImage} />
      <Services />
      <Brands />
      <Testimonials2 />
      {/* <Testimonials /> */}
      {/* <Faqs /> */}
      <Banner />
      <Footer1 />
    </>
  );
}
